import { Component, OnDestroy, OnInit } from '@angular/core';
import {Location} from '@angular/common';

import {
    AppAlertService,
    DatabaseService,
    ParametersService,
    SettingsAccountService,
    SubtitlesService,
    TilesService,
    ViewsService,
    ZonesService,
    ZonesSystemService
} from "../../core";
import {ZonesData} from "../../models";
import {Subscription} from "rxjs";

@Component({
    selector: 'zones',
    templateUrl: './zones.component.html',
    styleUrls: ['./zones.component.scss']
})
export class ZonesComponent implements OnInit, OnDestroy {
    private zonesSubscription: Subscription;

    constructor(
        private appAlert: AppAlertService,
        public database: DatabaseService,
        private location: Location,
        public parameters: ParametersService,
        private settingsAccount: SettingsAccountService,
        private subtitles: SubtitlesService,
        private tiles: TilesService,
        public views: ViewsService,
        public zones: ZonesService,
        public zonesSystem: ZonesSystemService,
    ) {
    }

    ngOnInit() {
        this.zonesSubscription = this.database.zonesResponse.subscribe(response => {
            if (response === null) return;

            this.views.zonesView.downloaded = true;

            if (response.zones.elements !== undefined && response.zones.elements.length > 0) {
                this.views.zonesView.withoutGlobalSchedules = response.zones.controllerParameters !== undefined
                    && response.zones.controllerParameters.globalSchedulesNumber !== undefined
                    && 'value' in response.zones.controllerParameters.globalSchedulesNumber
                    && response.zones.controllerParameters.globalSchedulesNumber.value === 0;

                if (response.zones.controllerParameters.controllerMode.hasOwnProperty('value')) {
                    const zonesData = this.database.zones.getValue() as ZonesData;
                    this.zones.zonesParameter = zonesData.controllerParameters?.controllerMode
                        ? zonesData.controllerParameters.controllerMode
                        : response.zones.controllerParameters.controllerMode;
                } else {
                    this.zones.zonesParameter = {};
                }

                this.zones.checkNoActiveZones();

                if (this.parameters.isZonesSystemControllerType() && this.location.path().includes('home')) {
                    this.zonesSystem.setContainers();
                }

                if (!this.parameters.isZonesSystemControllerType()) {
                    this.zonesSystem.resetZonesSystemService();
                }

                this.zones.currentlyOpenDropdown = 0;
            }

            // zones system controller after restart
            if(response.zones.elements.length === 0 && this.parameters.isZonesSystemControllerType()) {
                this.zonesSystem.setContainers();
            }
        });
    }

    ngOnDestroy() {
        if (this.zonesSubscription) {
            this.zonesSubscription.unsubscribe();
        }
    }

    subtitle(id: number) {
        return this.subtitles.setSubtitle(id);
    }

    getControlModeName(): string {
        const array = [3109, 1401, 809, 4325];
        return this.subtitle(array[this.zones.zonesParameter.value]);
    }

    showAlertControllerMode() {
        const message = '<div class="text-align-center">'
            + this.subtitle(3960) + ' '
            + this.getControlModeName() + '<br/>'
            + this.subtitle(3961) + '</div>';

        this.appAlert.showAppAlert(message, this.subtitles.setSubtitle(1006),
            this.zones.openControl.bind(this.zones), this.subtitles.setSubtitle(71), null);
    }

    hasTiles(): boolean {
        const tilesData = this.database.tiles.getValue();
        if (Array.isArray(tilesData)) {
            return tilesData.length === 0
        }
        return false;
    }

    registerModule() {
        this.settingsAccount.getAccountInformation();
        this.tiles.registerModule()
    }
}
